import React, { useEffect, useContext } from "react";
import { Context } from "../store/GlobalStore";
import firebase from "../store/Firestore";
import GpsFixedIcon from "@material-ui/icons/GpsFixed";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  MarkerClusterer,
  InfoWindow,
} from "@react-google-maps/api";

import "../App.css";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const mapContainerStyle = {
  //size of map
  width: "100vw",
  height: "85vh",
};

const center = {
  //starting location of map
  lat: 48.714084,
  lng: 21.235755,
};

declare global {
  interface Window {
    google: any;
  }
}

export default function Map() {
  const { store, dispatch } = useContext(Context);

  const changeLocation = (latitude: number, longitude: number) => {
    dispatch({
      type: "CHANGE_LOCATION",
      lat: store.lat,
      lng: store.lng,
      newLat: latitude,
      newLng: longitude,
    });
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyBLNYPM9BtVbck3fNAYydi4BKkl6DqXEZc", //google api key loaded from .env.local
  });

  const [markers, setMarkers] = React.useState([]); //array of markers(traffic signs)
  const [selected, setSelected] = React.useState<any>(null); //selected marker for showing of info
  const [loading, setLoading] = React.useState<boolean>(true);
  const [clicked, setClicked] = React.useState<any>(null); //selected marker for showing of info

  useEffect(() => {
    const db = firebase.firestore();

    let images: any = [];

    const signRef = db.collection("sign");
    const imageRef = db.collection("signImages");

    imageRef.onSnapshot(
      { includeMetadataChanges: false }, //load all the sign images
      function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          images.push({
            id: childSnapshot.id,
            name: childSnapshot.data().name,
            image: childSnapshot.data().image,
          });
        });
      }
    );

    signRef.onSnapshot(
      { includeMetadataChanges: false }, //load all the signs
      function (snapshot) {
        let a: any = [];
        snapshot.forEach(function (childSnapshot) {
          let img: any = images.find(
            (element: any) => element.name === childSnapshot.data().name
          );
          if (img !== undefined) {
            img = img.image;
          } else {
            console.log("Didn't find image for " + childSnapshot.data().name);
          }
          a.push({
            id: childSnapshot.id,
            image: img,
            name: childSnapshot.data().name,
            direction: childSnapshot.data().headingDirection,
            lat: childSnapshot.data().location.latitude,
            lng: childSnapshot.data().location.longitude,
            time: childSnapshot.data().createdDate,
          });
        });
        setMarkers(a);
      }
    );
    setLoading(false);
  }, []);

  const panTo = React.useCallback(({ lat, lng }) => {
    //move map to given lat and lng
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(14);
  }, []);

  const history = useHistory();

  function onMapClick(e: any) {
    //function that handles placing traffic signs where the user clicked
    //send lat lng and time to form
    console.log(
      "clicked on lat:" +
        e.latLng.lat() +
        " lng:" +
        e.latLng.lng() +
        " at " +
        new Date()
    );
    setClicked({
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    });
  }

  function moveToForm() {
    //move to form with clicked lat and lng
    changeLocation(clicked.lat, clicked.lng);
    history.push("/Camera");
  }

  const mapRef = React.useRef<any>(); //reference to map so we can do stuff with it without rerendering the map
  const onMapLoad = React.useCallback((map) => {
    //setting reference to map
    mapRef.current = map;
  }, []);

  if (loadError) return <div>Error while loading the map !</div>; //if there was error loading map
  if (!isLoaded) return <div>Loading map...</div>; //while loading map...

  return (
    <div>
      <Locate panTo={panTo} />
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={8}
        center={center}
        options={{
          //options for map
          backgroundColor: "gray", //background when its loading
          styles: store.mapTheme, //style of map
          disableDefaultUI: true, //disables dafualt UI so we can we use our own
          zoomControl: true, //enables default zoom control buttons
        }}
        onLoad={onMapLoad}
        onClick={(e) => onMapClick(e)}
      >
        {!loading ? ( //dont render markers while theyre loading
          <MarkerClusterer averageCenter enableRetinaIcons gridSize={60}>
            {(clusterer) =>
              markers.map((marker: any) => (
                <Marker
                  key={marker.id} //puts markers where they are supposed to be
                  position={{ lat: marker.lat, lng: marker.lng }}
                  clusterer={clusterer}
                  icon={{
                    url: "/signs_assets/" + marker.image,
                    scaledSize: new window.google.maps.Size(30, 30),
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(15, 15),
                  }}
                  onClick={() => {
                    setSelected(marker);
                    console.log(selected);
                  }}
                />
              ))
            }
          </MarkerClusterer>
        ) : null}
        {selected ? ( //renders infowindow of selected marker
          <InfoWindow
            position={{ lat: selected.lat, lng: selected.lng }}
            onCloseClick={() => {
              setSelected(null);
            }}
          >
            <div>
              <h2>{selected.name}</h2>
              <p>This sign is facing {selected.direction}</p>
              <p>Sign was added {selected.time}</p>
              <button
                onClick={() => {
                  alert("Button for change clicked");
                }}
              >
                Change
              </button>
            </div>
          </InfoWindow>
        ) : null}
        {clicked ? ( //renders infowindow of clicked location
          <InfoWindow
            position={{ lat: clicked.lat, lng: clicked.lng }}
            onCloseClick={() => {
              setClicked(null);
            }}
          >
            <div>
              <h2>Clicked here !</h2>

              <p>
                Do you wish to add sign on lat: {clicked.lat} lng: {clicked.lng}
              </p>
              <button
                onClick={() => {
                  moveToForm();
                }}
              >
                Yes
              </button>
            </div>
          </InfoWindow>
        ) : null}
      </GoogleMap>
    </div>
  );
}

function Locate(e: any) {
  //function for getting user's current location
  let { panTo } = e;
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<GpsFixedIcon />}
      onClick={() => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            panTo({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          () => null
        );
      }}
    >
      Show my position
    </Button>
  );
}
